<template>

		
			<!-- aktiva filter -->
			<div v-if="layout == 'desktop'"  id="">
				<div class="flexcenter filter-list" style="">
					<!-- kategori -->
					<div v-if="this.categoryFilterLabel" class="flexcenter filter link" style=""
						@click.stop="this.removeCategory()">
						<b class="font-small">{{ this.categoryFilterLabel }}</b>
						<Icon fileName="w3_circle_close_white" style="" />
					</div>

					<!-- MC -->
					<div v-if="this.mcFilterLabel" class="flexcenter filter link" style="" @click.stop="this.removeMc()">
						<b class="font-small">{{ this.mcFilterLabel }}</b>
						<Icon fileName="w3_circle_close_white" style="" />
					</div>

					<!-- tillverkare -->
					<div v-if="this.manufactorFilterLabel" class="flexcenter filter link" style=""
						@click.stop="this.removeManufactor()">
						<b class="font-small">{{ this.manufactorFilterLabel }}</b>
						<Icon fileName="w3_circle_close_white" style="" />
					</div>
				</div>

				<div>

				</div>


			</div>

			<div v-if="this.layout != 'desktop' && this.filterLabel" class="link" @click.stop="this.removeAll()">
				<div class="filter flexcenter" style="">
					<b class="font-small">{{ this.filterLabel }}</b>
					<Icon fileName="w3_circle_close_white" style="" />
				</div>
			</div>



</template>
<script>
import { STORE_GETTER } from '../../store/store';



export default {
	name: "ActiveFilterList",
	components: {},
	mixins: [],
	props: {
		layout: {
			type: String,
			default: "desktop"
		}
	},
	data() {
		return {
		};
	},
	computed: {
		searchProductConfig() {
			return this.$store.getters[STORE_GETTER.SEARCH_PRODUCT_CONFIG];
		},

		categoryFilterLabel() {
			return this.searchProductConfig?.category?.name
		},

		mcFilterLabel() {
			var mc = "";

			if (this.searchProductConfig?.brand) {
				mc = this.searchProductConfig?.brand?.name
			}

			if (this.searchProductConfig?.mc) {
				mc = mc + ' ' + this.searchProductConfig?.mc?.modelName
			}

			if (this.searchProductConfig?.year) {
				mc = mc + ' ' + this.searchProductConfig?.year?.year
			}

			return mc
		},

		manufactorFilterLabel() {
			return this.searchProductConfig?.manufactor?.name
		},

		filterLabel() {
			var count = 0;

			if (this.categoryFilterLabel) {
				count++;
			}

			if (this.mcFilterLabel && this.mcFilterLabel != "") {
				count++;
			}

			if (this.manufactorFilterLabel) {
				count++;
			}

			if (count === 0) {
				return null;
			}

			return count + " filter";
		}

	},
	watch: {
		
	},

	methods: {
	

		removeCategory() {
			this.searchProductConfig.category = null;
		},


		removeManufactor() {
			this.searchProductConfig.manufactor = null;
		},

		removeMc() {
			this.searchProductConfig.brand = null;
			this.searchProductConfig.mc = null;
			this.searchProductConfig.year = null;
		},

		removeAll() {
			this.removeCategory();
			this.removeManufactor();
			this.removeMc();
		}


	},
	created() {

	}
};
</script>

<style scoped>


div.filter-list {
	flex-wrap: nowrap;
	width: max-content;


}

div.filter {
	background: var(--bg-message);
	padding: 3px;
	padding-left: 5px;
	padding-right: 5px;
	margin-right: 5px;
	color: white;
	border-radius: 5px;
	white-space: nowrap;


}

div.filter img {
	margin-left: 5px;
	height:20px;
	width:20px;
}

</style>